import script from "./InvoiceSection3.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceSection3.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceSection3.vue?vue&type=style&index=0&id=3f939c40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f939c40"]])

export default __exports__